// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Search } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconSearch(props: any) {
    return <IconBase icon={Search} {...props} />
  }

  export default IconSearch
  